import { useGetEmailRule, useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { ProfileFields } from '../helpers';

export const useValidationFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const emailRule = useGetEmailRule({ t });

  return {
    [ProfileFields.FULL_NAME]: [requiredRule],
    [ProfileFields.EMAIL]: [requiredRule, emailRule],
  };
};
